/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Legal_SectionInputs */



/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Help_Legal_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_legal_section = /** @type {((inputs?: Help_Legal_SectionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Legal_SectionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mentions légales")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avisos legales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Avisos legais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note legali")
	return /** @type {LocalizedString} */ ("Legal")
});